export const update = {
  form: {
    name: 'Name',
    code: 'Code',
    isDefault: 'Is Default',
    update: 'Update',
    requireName: 'Please input language name!',
    requireCode: 'Please input language code!',
  },
  pageHeader: {
    title: 'Update Language',
    back: 'Back',
  },
}
